import { MARKET_API_URL } from "../config";
import React, { useState, useEffect, useContext } from "react";
import { Tooltip, Grow } from "@mui/material";
import BarChartIcon from '@mui/icons-material/BarChart';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import axios from "axios";

import GeneralContext from "./GeneralContext";
import { MarketContext } from "../context/MarketContext";
import ChartModal from "./ChartModal";

const DEFAULT_WATCHLIST_1 = [
  { name: "BANKEX", tag: "INDEX", change: "-285.80", percent: "-0.44%", isDown: true, price: 64603.35 },
  { name: "NIFTY FIN SERVICE", tag: "INDEX", change: "-131.65", percent: "-0.50%", isDown: true, price: 26155.45 },
  { name: "SENSEX", tag: "INDEX", change: "+28.34", percent: "+0.04%", isDown: false, price: 77682.94 },
  { name: "NIFTY MID SELECT", tag: "INDEX", change: "-35.55", percent: "-0.24%", isDown: true, price: 14647.50 },
  { name: "TATAELXSI", tag: "", change: "-19.40", percent: "-0.53%", isDown: true, price: 3654.00 },
  { name: "DIXON", tag: "EVENT", change: "+104.00", percent: "+0.73%", isDown: false, price: 14379.00 },
  { name: "RELIANCE", tag: "", change: "+14.20", percent: "+0.55%", isDown: false, price: 2426.50 },
  { name: "HDFCBANK", tag: "", change: "-4.50", percent: "-0.27%", isDown: true, price: 1618.20 }
];

const DEFAULT_WATCHLIST_FNO = [
  { name: "NIFTY24500CE", tag: "OPT", change: "+4.50", percent: "+3.20%", isDown: false, price: 150.0 },
  { name: "NIFTY24500PE", tag: "OPT", change: "-3.10", percent: "-2.10%", isDown: true, price: 140.0 },
  { name: "BANKNIFTY52300CE", tag: "OPT", change: "+5.80", percent: "+1.80%", isDown: false, price: 320.0 },
  { name: "BANKNIFTY52300PE", tag: "OPT", change: "-4.50", percent: "-1.50%", isDown: true, price: 290.0 }
];

const WatchList = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [customWatchlist, setCustomWatchlist] = useState([]);
  const [chartSymbol, setChartSymbol] = useState(null);

  const { ticks, addSubscribedSymbols } = useContext(MarketContext);

  const currentList = activeTab === 0 ? DEFAULT_WATCHLIST_1 : activeTab === 1 ? DEFAULT_WATCHLIST_FNO : customWatchlist;

  useEffect(() => {
    const syms = currentList.map(s => s.name);
    addSubscribedSymbols(syms);
  }, [currentList, addSubscribedSymbols]);

  const handleSearchChange = async (e) => {
    const q = e.target.value;
    setSearchTerm(q);
    if (q.trim().length > 1) {
      try {
        const res = await axios.get(`${MARKET_API_URL}/api/smartapi/search?q=${q}`);
        setSearchResults(Array.isArray(res.data) ? res.data : (res.data?.SearchResults?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
      } catch (err) {
        setSearchResults([]);
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleAddSymbol = (symbol) => {
    if (!customWatchlist.find(s => s.name === symbol)) {
      const newItem = { name: symbol, tag: "EQ", change: "+0.00", percent: "+0.00%", isDown: false, price: 100.0 };
      setCustomWatchlist(prev => [...prev, newItem]);
      addSubscribedSymbols([symbol]);
    }
    setSearchTerm("");
    setSearchResults([]);
    setActiveTab(2);
  };

  const handleDeleteCustomItem = (symbol) => {
    setCustomWatchlist(prev => prev.filter(item => item.name !== symbol));
  };

  return (
    <div className="watchlist-container" style={{ width: "360px", minWidth: "360px", borderRight: "1px solid #eee", backgroundColor: "#ffffff", display: "flex", flexDirection: "column", height: "100%", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
      {chartSymbol && <ChartModal symbol={chartSymbol} onClose={() => setChartSymbol(null)} />}

      {/* Zerodha Search Bar */}
      <div className="search-container" style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0", position: "relative" }}>
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <span style={{ position: "absolute", left: "10px", color: "#999", fontSize: "14px" }}>🔍</span>
          <input
            type="text"
            name="search"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Search eg: infy bse, nifty fut, index fund, e..."
            style={{
              width: "100%",
              padding: "8px 30px 8px 32px",
              borderRadius: "4px",
              border: "1px solid #e0e0e0",
              fontSize: "12px",
              boxSizing: "border-box",
              backgroundColor: "#fafafa"
            }}
          />
          <span style={{ position: "absolute", right: "10px", fontSize: "10px", color: "#999", border: "1px solid #ddd", padding: "1px 4px", borderRadius: "3px", backgroundColor: "#fff" }}>
            Ctrl + K
          </span>
        </div>

        {searchResults.length > 0 && (
          <div style={{ position: "absolute", top: "46px", left: "14px", right: "14px", backgroundColor: "#fff", boxShadow: "0 4px 16px rgba(0,0,0,0.15)", borderRadius: "6px", maxHeight: "220px", overflowY: "auto", zIndex: 100, border: "1px solid #eee" }}>
            {searchResults.map((item) => (
              <div
                key={item.token || item.symbol}
                onClick={() => handleAddSymbol(item.symbol)}
                style={{ padding: "8px 12px", fontSize: "12px", cursor: "pointer", borderBottom: "1px solid #f5f5f5", display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <div>
                  <strong>{item.symbol}</strong>
                  <span style={{ fontSize: "10px", color: "#999", marginLeft: "6px" }}>{item.exch_seg || "NSE"}</span>
                </div>
                <span style={{ color: "#387ed1", fontWeight: "bold", fontSize: "11px" }}>+ Add</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Watchlist Header Info: Watchlist 1 (51 / 250) + New group */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 14px", fontSize: "12px", color: "#9b9b9b", borderBottom: "1px solid #f0f0f0", backgroundColor: "#fafafa" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Watchlist {activeTab + 1} ({currentList.length} / 250)</span>
          <span style={{ cursor: "pointer" }}>↓ ↑</span>
        </div>
        <button onClick={() => setActiveTab(2)} style={{ background: "none", border: "none", color: "#387ed1", fontSize: "12px", cursor: "pointer", fontWeight: 500 }}>
          + New group
        </button>
      </div>

      {/* Symbol List */}
      <ul className="list" style={{ listStyle: "none", margin: 0, padding: 0, overflowY: "auto", flex: 1 }}>
        {currentList.map((stock, index) => {
          const liveTick = ticks[stock.name] || {};
          const price = liveTick.price !== undefined ? liveTick.price : stock.price;
          const percent = liveTick.percentChange || stock.percent;
          const isDown = liveTick.isDown !== undefined ? liveTick.isDown : stock.isDown;
          const changeVal = stock.change || (isDown ? "-0.50" : "+0.50");

          return (
            <WatchListItem
              key={stock.name || index}
              symbol={stock.name}
              tag={stock.tag}
              price={price}
              change={changeVal}
              percent={percent}
              isDown={isDown}
              onOpenChart={setChartSymbol}
              onDelete={activeTab === 2 ? () => handleDeleteCustomItem(stock.name) : null}
            />
          );
        })}
      </ul>
    </div>
  );
};

const WatchListItem = ({ symbol, tag, price, change, percent, isDown, onOpenChart, onDelete }) => {
  const [hover, setHover] = useState(false);
  const [flash, setFlash] = useState("");

  useEffect(() => {
    setFlash(isDown ? "flash-down" : "flash-up");
    const timer = setTimeout(() => setFlash(""), 350);
    return () => clearTimeout(timer);
  }, [price, isDown]);

  const color = isDown ? "#f23645" : "#089981";

  return (
    <li
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "relative",
        borderBottom: "1px solid #f0f0f0",
        padding: "10px 14px",
        transition: "background-color 0.2s ease-in-out",
        backgroundColor: hover ? "#fcfcfc" : flash === "flash-up" ? "rgba(8, 153, 129, 0.1)" : flash === "flash-down" ? "rgba(242, 54, 69, 0.1)" : "#ffffff"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        
        {/* Left: Symbol & Badge Tag */}
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ fontWeight: 500, fontSize: "13px", color: isDown ? "#f23645" : "#444" }}>
            {symbol}
          </span>
          {tag && (
            <span style={{ fontSize: "9px", color: "#999", backgroundColor: "#f0f0f0", padding: "1px 4px", borderRadius: "2px", fontWeight: "bold" }}>
              {tag}
            </span>
          )}
        </div>

        {/* Right: Change | Percent | Arrow | LTP */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px" }}>
          <span style={{ color: "#888", fontSize: "11px" }}>{change}</span>
          <span style={{ color: color, fontSize: "11px", minWidth: "45px", textAlign: "right" }}>{percent}</span>
          <span style={{ color: color, fontSize: "10px" }}>{isDown ? "∨" : "∧"}</span>
          <span style={{ fontWeight: 600, color: color, minWidth: "65px", textAlign: "right" }}>
            {price ? Number(price).toFixed(2) : "0.00"}
          </span>
        </div>
      </div>

      {hover && <WatchListActions uid={symbol} onOpenChart={onOpenChart} onDelete={onDelete} />}
    </li>
  );
};

const WatchListActions = ({ uid, onOpenChart, onDelete }) => {
  const { openBuyWindow, openSellWindow } = useContext(GeneralContext);
  return (
    <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", display: "flex", gap: "4px", backgroundColor: "#ffffff", padding: "2px 4px", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0,0,0,0.18)" }}>
      {/* Buy B Button */}
      <Tooltip title="Buy (B)" arrow placement="top" TransitionComponent={Grow}>
        <button
          onClick={() => openBuyWindow(uid)}
          style={{ backgroundColor: "#4184f3", color: "#ffffff", border: "none", padding: "3px 9px", borderRadius: "3px", fontWeight: "bold", cursor: "pointer", fontSize: "11px" }}
        >
          B
        </button>
      </Tooltip>

      {/* Sell S Button */}
      <Tooltip title="Sell (S)" arrow placement="top" TransitionComponent={Grow}>
        <button
          onClick={() => openSellWindow(uid)}
          style={{ backgroundColor: "#ff5722", color: "#ffffff", border: "none", padding: "3px 9px", borderRadius: "3px", fontWeight: "bold", cursor: "pointer", fontSize: "11px" }}
        >
          S
        </button>
      </Tooltip>

      {/* Chart Button */}
      <Tooltip title="Chart" arrow placement="top" TransitionComponent={Grow}>
        <button
          onClick={() => onOpenChart(uid)}
          style={{ backgroundColor: "#ffffff", border: "1px solid #e0e0e0", padding: "3px 6px", borderRadius: "3px", cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          <BarChartIcon style={{ fontSize: "14px", color: "#666" }} />
        </button>
      </Tooltip>

      {/* Market Depth Button */}
      <Tooltip title="Market Depth" arrow placement="top" TransitionComponent={Grow}>
        <button
          style={{ backgroundColor: "#ffffff", border: "1px solid #e0e0e0", padding: "3px 6px", borderRadius: "3px", cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          <FormatListNumberedIcon style={{ fontSize: "14px", color: "#666" }} />
        </button>
      </Tooltip>

      {/* Delete Button (if custom) */}
      {onDelete && (
        <Tooltip title="Delete" arrow placement="top" TransitionComponent={Grow}>
          <button
            onClick={onDelete}
            style={{ backgroundColor: "#ffffff", border: "1px solid #e0e0e0", padding: "3px 6px", borderRadius: "3px", cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <DeleteOutlineIcon style={{ fontSize: "14px", color: "#ef5350" }} />
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default WatchList;